/** トップレベルナビゲーションのリンクと表示名。 */
export const topLevelNavigations = [
  {
    url: '#messages',
    displayName: 'メッセージ',
    isMessages: true,
  },
  {
    url: '/jian-list',
    displayName: '事案一覧',
  },
];
